import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createSuccessFlagTitle: {
		id: 'business-issue-create.controllers.show-create-success-flag.create-success-flag-title',
		defaultMessage: 'You\'ve created issue "{issueKey}"',
		description: 'Title for success flag when an issue is successfully created.',
	},
	viewIssueLinkText: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX - ENABLING FLAT LINT CONFIG
		id: 'business-issue-create.controllers.show-create-success-flag.view-issue-link-text',
		defaultMessage: 'View issue',
		description: 'CTA for success flag when issue is created to navigate to the issue view.',
	},
});
